/* @jsxImportSource react */

/**
 * EnergyEfficiencyIconOld component.
 *
 * Styling has to be completely managed by the parent component and passed via `className` param.
 */
export const LegacyEnergyEfficiencyFlagIcon = ({ className }: { className: string }) => (
  <svg className={className} viewBox="0 0 35 20">
    <path fill="currentColor" d="M26.1,0H0v20h26.1L35,9.6L26.1,0z" />
  </svg>
);

LegacyEnergyEfficiencyFlagIcon.displayName = 'EnergyEfficiencyIconOld';
